<template>
  <div>
    <v-layout align-center style="height: 80px" class="title">
      <span class="pl-4">个人预约记录</span>
    </v-layout>
    <reservation-list class="px-2"></reservation-list>
<!--    <v-expand-transition>-->
<!--      <reservation-list v-if="showHistory" class="px-2" history></reservation-list>-->
<!--    </v-expand-transition>-->
<!--    <v-flex class="text-xs-center">-->
<!--      <v-btn flat color="primary" @click="showHistory = !showHistory">{{showHistory ? '收起':'展开'}}预约历史</v-btn>-->
<!--    </v-flex>-->
  </div>
</template>

<script>

import ReservationList from './reservationList'
export default {
  name: 'personalReservationList',
  components: {ReservationList},
  data: () => ({
    showHistory: false
  }),
}
</script>

<style scoped>

</style>
